// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Redux:
import { setSelectedAnimal } from 'actions/animals'
import { selectedAnimal } from 'selectors/animals'

class Animal extends React.Component {
	handleClick = () => {
		this.props.setSelectedAnimal( this.props.id )
	}

	render() {
		const { match, data, id, name, imageUrl, tagline, sex, breed, age, showBondLeft, showBondRight, bondedPair, showAdopted } = this.props
		let pagePath = '/' + match.params.page
		let bondClass = showBondLeft ? '-bond -bond-left' : '-bond -bond-right'

		if ( match.params.subpage ) {
			pagePath += '/' + match.params.subpage
		}

		const animalUrl = pagePath + '/animal/' + id + '/'
		const Wrap = showAdopted ? 'div' : Link
		const wrapClass = showAdopted ? 'animal -is-adopted' : 'animal'
		const wrapInnerProps = showAdopted ? {} : {
			onClick: this.handleClick
		}

		return (
			<Wrap to={ animalUrl } className={ wrapClass } data-id={ id }>
				<div className="-wrap">
					<div className="-inner" { ...wrapInnerProps }>
						<div className="-image">
							<img className="lozad" data-src={ imageUrl } alt={ name } />

							{ ( showBondLeft || showBondRight ) &&
								<div className={ bondClass }>
									<i className="icon-link-streamline" aria-hidden="true" />
								</div>
							}

							<div className="-badges">
								{ data.is_desexed &&
									<div className="-is-desexed">
										{ 'Male' == sex &&
											<i className="icon-mars-stroke-solid" aria-hidden="true" />
										||
											<i className="icon-neuter-solid" aria-hidden="true" />
										}
									</div>
								}

								{ data.is_microchipped &&
									<div className="-is-microchipped">
										<i className="icon-microchip-solid" aria-hidden="true" />
									</div>
								}

								{ data.is_vaccinated &&
									<div className="-is-vaccinated">
										<i className="icon-syringe-solid" aria-hidden="true" />
									</div>
								}
							</div>
						</div>

						<div className="-info">
							<h3>{ name }</h3>

							{ ( ! showAdopted && tagline ) &&
								<p>
									<span className="-tagline" dangerouslySetInnerHTML={ { __html: tagline } } />
								</p>
							}

							{ ! showAdopted &&
								<p>
									{ sex }
									{ breed && <br /> }
									{ breed }
									<br />
									{ age }
								</p>
							}
						</div>
					</div>
				</div>
			</Wrap>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		selectedAnimal: selectedAnimal( state ),
		showAdopted: state.animals.showAdopted
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		setSelectedAnimal: ( id ) => {
			dispatch( setSelectedAnimal( id ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Animal )



// WEBPACK FOOTER //
// ./views/main/page/Animal.jsx